/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const ContentIssue = zod
  .unknown()
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(
    zod.object({
      code: zod.enum([
        "SOURCE_MISSING",
        "SOURCE_INACTIVE",
        "SUPPLIER_NOT_SELECTABLE",
        "TERMS_UNPRICED",
        "LEAF_COVERAGE_INVALID",
        "CURRENCY_MISMATCH",
        "QUANTITY_UNRESOLVED",
        "VARIABLE_UNRESOLVED",
      ]),
      scope: zod
        .union([
          zod.literal("HEADER"),
          zod.literal("BLOCK"),
          zod.literal("FOOTER"),
          zod.literal(null),
        ])
        .nullish(),
      chapterId: zod.uuid().nullish(),
      blockId: zod.uuid().nullish(),
      leafCatalogItemId: zod.uuid().nullish(),
      variableName: zod.string().nullish(),
    }),
  )
  .describe(
    "Repairable business issues only. Source issues can be Offer-level for an unresolved selected Commission, with no block location. No Commission selected means zero; unresolved selection does not. Captured party state changes add no new eligibility rule. Authored null quantity is implicit one and never emits QUANTITY_UNRESOLVED; that retained code identifies explicit unusable nonpositive quantities. Infrastructure\/projection faults remain failures, not issues.",
  );

export type ContentIssue = zod.input<typeof ContentIssue>;
export type ContentIssueOutput = zod.output<typeof ContentIssue>;
